import { Controller } from "@hotwired/stimulus"

const CHARACTER_DELAY = 58
const DOT_DELAY = 220
const MESSAGE_PAUSE = 750
const FINAL_DOTS_PAUSE = 650
const ELAPSED_INTERVAL = 1000

export default class extends Controller {
  static targets = ["elapsed", "text"]
  static values = { messages: Array }

  connect() {
    this.startedAt = Date.now()
    this.#updateElapsed()
    this.elapsedTimer = setInterval(() => this.#updateElapsed(), ELAPSED_INTERVAL)

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.textTarget.textContent = `${this.messagesValue.at(-1)}...`
      return
    }

    this.messageIndex = 0
    this.characterIndex = 0
    this.textTarget.textContent = ""
    this.#typeNextCharacter()
  }

  disconnect() {
    clearInterval(this.elapsedTimer)
    clearTimeout(this.animationTimer)
  }

  #typeNextCharacter() {
    const message = this.messagesValue[this.messageIndex]
    if (this.characterIndex < message.length) {
      this.textTarget.textContent += message[this.characterIndex]
      this.characterIndex += 1
      this.animationTimer = setTimeout(() => this.#typeNextCharacter(), CHARACTER_DELAY)
      return
    }

    this.dotCount = 0
    this.#typeNextDot()
  }

  #typeNextDot() {
    const message = this.messagesValue[this.messageIndex]
    if (this.dotCount < 3) {
      this.dotCount += 1
      this.textTarget.textContent = `${message}${".".repeat(this.dotCount)}`
      this.animationTimer = setTimeout(() => this.#typeNextDot(), DOT_DELAY)
      return
    }

    if (this.messageIndex === this.messagesValue.length - 1) {
      this.animationTimer = setTimeout(() => this.#restartFinalDots(), FINAL_DOTS_PAUSE)
      return
    }

    this.animationTimer = setTimeout(() => this.#startNextMessage(), MESSAGE_PAUSE)
  }

  #restartFinalDots() {
    this.dotCount = 0
    this.textTarget.textContent = this.messagesValue[this.messageIndex]
    this.animationTimer = setTimeout(() => this.#typeNextDot(), DOT_DELAY)
  }

  #startNextMessage() {
    this.messageIndex += 1
    this.characterIndex = 0
    this.textTarget.textContent = ""
    this.#typeNextCharacter()
  }

  #updateElapsed() {
    const elapsedSeconds = Math.floor((Date.now() - this.startedAt) / ELAPSED_INTERVAL)
    this.elapsedTarget.textContent = `${elapsedSeconds}s`
  }
}
